// @flow
import React from 'react';
import { withLocalize } from 'react-localize-redux';
 

const LanguageToggle = ({languages, activeLanguage, setActiveLanguage}) => {
  const getClass = (languageCode) => {
      return languageCode === activeLanguage.code ? 'dropdown-item active' : 'dropdown-item'
  };

    return (

        <li class="dropdown navbar-user">

            <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown">
                <i class="fas fa-lg fa-fw m-r-10 fa-globe text-primecolor"></i>
                <span class="d-none d-md-inline">Change Language</span> <b class="caret"></b>
            </a>
            <div class="dropdown-menu dropdown-menu-right">
                
            
        
          
          {languages.map(lang => 

              
              <a href="javascript:;" className={getClass(lang.code)} onClick={() => {   window.SetLanguage(lang.dir);  setActiveLanguage(lang.code)} } >
                  <span class="d-none d-md-inline"><span className={lang.icon}></span> {lang.name} </span>
              </a>
                  
             
   
          )}
            </div>
      </li> 
  );
};

export default withLocalize(LanguageToggle);


// WEBPACK FOOTER //
// ./src/components/LanguageToggle.js